

import Config from "../Config";

import { useState, useEffect} from "react";

import input_check from "../input_check.png";
import input_error from "../input_error.png";
import ClientForm from "../module/home/ClientForm";



function InputSearchClient(props)
{

    var cData = null;

    //cData = Config.getFromBuffer(Config.cache_emps_search,60, props.userData);
     
    var vVal = '';
    if(props.value != null && props.value != undefined) vVal = props.value;
    
    const [val, setVal] = useState(vVal);
   // const [val, setVal] = useState('');
    const [req, setRequired] = useState(props.req);
    const [firstUp, setFirstUp] = useState(props.firstUp);
    const [cn, setClassName] = useState('');

    const [onShow,setOnShow] = useState(false);

    const [showSelect, setShowSelect] = useState(false);

    const [tab, setTab] = useState(cData); 


    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [newClientDialog, setNewClientDialog] = useState(0);
  
   

    const checkAndChange = (e) =>
    {

 

        var v = e.target.value;

        setShowSelect(true);



        if(firstUp != undefined && firstUp == '1')
        {
            v =  v.charAt(0).toUpperCase() + v.slice(1);
        }


        setVal(v);

        var correct = true;

        if(req == '1' && v.length < 1) correct = false;         
    
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }

        if(props.valChange != null && props.valChange != undefined)
        {
            props.valChange(props.name, v, correct,'');
        }else
        {
            console.log('No support for valChange');
        }    
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
               if(props.goNext != null && props.goNext != undefined)
               {
                  props.goNext();
               }
          } 
    }



    const getEmps = (idF) => {
       
 
       

        fetch( Config.url + '/rest_v1_home,search_client', {
            method: 'POST', 
            body: JSON.stringify([]), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                      
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);       
                        Config.setToBuffer(Config.cache_emps_search, res.result, props.userData); 

                        if(props.me != undefined && props.me == "1"  && res.meId != undefined)
                        {
                            setVal(res.meId + " | " + res.meName);
                        }


                        if(idF != undefined)
                        {
                       
                                            var valx = "";
                                        
                                            for(var k=0;k<res.result.length; k++)
                                            {
                                                if(res.result[k].id == idF)
                                                    {
                                                        valx = res.result[k].id + " | "  +  res.result[k].nip+" " + res.result[k].nazwa;
                                                    }
                                            }

                                            if(props.empSelected != null && props.empSelected != undefined)
                                            {              
                                                props.empSelected(idF);
                                            }                                                                                         

                                            setVal(valx);
                            

                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                
         });
                   

         return false;
    }


    const selectAndClose = (e) => {

        var id = e.target.getAttribute('id');
        var valx = e.target.getAttribute('val');
                
        setShowSelect(false);


        for(var k=0;k<tab.length; k++)
            {
                if(tab[k].id == id)
                    {
                        valx = tab[k].id + " | "  +  tab[k].nip+" " + tab[k].nazwa;
                    }
            }

        if(props.empSelected != null && props.empSelected != undefined)
        {              
            props.empSelected(id);
        }       
        setVal(valx);
       
    }
    

    const closeDialog = () => {
        setShowSelect(false);
    }

    const showDialog = () => {
        setShowSelect(true);
    }


    const changeNewClientDialog = () => {


        if(newClientDialog == 0)
        {
            setNewClientDialog(1);
        }else setNewClientDialog(0);

    }


    if(cn.length < 2)
    {
        var correct = true;
        
        if(req == '1' && val != undefined && val.length < 1) correct = false;         
    
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }
    }


    var imgx = null;

    if(cn == "incorrent" && req=='1')
    {
        imgx = <img  className="input_status" src={input_error} />
    }

    
    if(cn == "corrent" && req=='1')
    {
        imgx = <img className="input_status" src={input_check} />
    }



    useEffect(() => {

        if(val != props.value && props.value != undefined) //aktualizuj jesli sie zmieni..
        {
           // setVal(props.value);
            setOnShow(false);
        }

        if( onShow == false && props.valChange != null && props.valChange != undefined ) //sprawdz czy dane sa poprawne i wyslij wyzej
        {
             var correct = true;
             if(cn == "incorrent" ) correct = false;                 
             setOnShow(true);

             
     
             props.valChange(props.name, val, correct,'');
            
    
        }
    })



    var err = "";
    if(props.err != undefined  &&  props.err != null ) 
    {       
        if(props.err[props.name] != null  && props.err[props.name] != undefined    ) err = props.err[props.name]['param'];
    }


    if(refreshView != props.userData.refreshView)
        {
            setRefreshView( props.userData.refreshView);
            setTab([]);
        }



    if(tab == null)
    {
        setTab([]);
        getEmps(-1);    
    }


    const onSuccess = (idF) => {
        
        getEmps(idF);

        setNewClientDialog(0);


      
    }


    var searchBox = null;
    var finded = new Array();


    if(val.length > 2 && tab != undefined )
    {
     
        finded = new Array();
        const valP = val.split(" ");

        for(var k=0;k<tab.length; k++)
        {                      
            if( valP[0].toLowerCase().length > 2 &&   (tab[k].nazwa.toLowerCase().includes(valP[0].toLowerCase() ) || tab[k].nip.toLowerCase().includes(valP[0].toLowerCase() ))  )
            {               
                finded.push( tab[k] ); 
            } else
            if(  valP.length > 1 &&   valP[1].toLowerCase().length > 2 && (  tab[k].nazwa.toLowerCase().includes(valP[1].toLowerCase() ) || tab[k].nip.toLowerCase().includes(valP[1].toLowerCase() ) )  )
            {               
                finded.push( tab[k] ); 
            } 
        }
    }


    if(finded.length > 0 && showSelect)
    {
     

            searchBox =   <div className="autocomplete shadowx">
                            <ul>
                                {
                                    finded.map( (item, ix) => {
                                        return <li key={"x"+ix}  id={item.id} val={item.nip + " " + item.nazwa } onClick={selectAndClose}  >
                                                {item.nip + " " + item.nazwa }
                                        </li>
                                    } )
                                }
                            </ul>
                        </div>  ;
    }


    var tmVal = val;

    console.log("XXX", tmVal, props.value);
    if( tab != null &&  props.value > 0 &&  tmVal != null && tmVal.split != null && tmVal.split("\n").length == 1 )
    {
        for(var k=0;k<tab.length; k++)
                    {
                        if(tab[k].id == props.value )
                            {
                                tmVal = tab[k].id + " | "  +  tab[k].nip+" " + tab[k].nazwa;
                            }
                    }
    }

    if(tmVal  == "-1") tmVal = "";


    var dialogNew = null;

    if(newClientDialog == 1)
    {
        dialogNew = <div className="dlg_window shadowx dlg_window_xx">
                <div className="dlg_title">Nowy klient</div>
                <div className="dlg_content">
                       <ClientForm  userData={props.userData} mainView={props.mainView} onBack={changeNewClientDialog}  onSuccess={onSuccess}   id={-1} />
                </div> 
        </div>
    }


    return <fieldset>
           <input type="text"   onFocus={showDialog}   value={tmVal} onChange={checkAndChange} onKeyDown={onKeyDown} name={props.name} placeholder={props.placeholder} className={props.className + "   " + cn} />        
             {imgx} <span className="btn" onClick={changeNewClientDialog}>nowy klient [+]</span>
             <br/>
             <span className="form_err">{err + " "} &nbsp; </span>    
             {searchBox} 
             {dialogNew}    
           </fieldset>
}


export default InputSearchClient;